import axiosInstance from './axiosInstance';
import CreateUserRequest from "../types/CreateUserRequest";
import LoginUserRequest from "../types/LoginUserRequest";
import UsersData from "../types/UsersData";
import CreateUserResponse from "../types/CreateUserResponse";
import EditUserRequest from "../types/EditUserRequest";
import User from "../types/User";

export const postUser = async (request: CreateUserRequest): Promise<CreateUserResponse | void> => {
    return axiosInstance.post<CreateUserResponse>("/users/register", request)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const loginUser = async (dto: LoginUserRequest): Promise<any> => {
    return axiosInstance.post("/users/login", dto)
        .then(response => response.data)
        .catch(error => {
            throw error
        });
}

export const fetchUsers = async () => {
    return axiosInstance.get<UsersData>("/users")
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const fetchUserBydId = async (id: number) => {
    return axiosInstance.get<User>(`/users/${id}`)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const editUser = async (id: number, payload: EditUserRequest): Promise<void> =>
    axiosInstance.patch<void>(`/users/${id}`, payload)
        .then(response => response.data)
        .catch(error => { throw error });

export const resetUserPassword = async (id: number, payload: any): Promise<void> =>
    axiosInstance.patch<void>(`/users/${id}/password`, payload)
        .then(response => response.data)
        .catch(error => { throw error });
